export default "__VITE_ASSET__BQlKxvRy__"